import formValidation from 'constants/validation';
import { Schema } from 'rsuite';

const { StringType, ArrayType } = Schema.Types;

const { errorMessages: err } = formValidation;

export const authSignInFormModel = Schema.Model({
  email: StringType()
    .isRequired('Please enter a valid email.')
    .isEmail('Please enter a valid email.'),
  password: StringType().isRequired('Please enter your password.'),
});

export const authForgotPasswordFormModel = Schema.Model({
  email: StringType().isRequired(err.email).isEmail(err.email),
});

export const bagelSmsConsentFormModel = Schema.Model({
  phoneNumber: StringType().isRequired('Please enter a valid phone number.'),
  // CheckboxFormField is backed by rsuite's CheckboxGroup, so a single checkbox's
  // value is `['consent']` when checked and `[]` when not — not a plain boolean.
  consent: ArrayType().minLength(1, 'You must agree to receive SMS messages.'),
});

/** Set / change / reset password flows (password + confirmation) */
export const authPasswordWithConfirmFormModel = Schema.Model({
  password: StringType()
    .isRequired('Please enter a valid password.')
    .minLength(6, 'Password must be 6 characters long.'),
  passwordConfirm: StringType()
    .isRequired('Please re-enter your password.')
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }
      return true;
    }, 'Passwords do not match.'),
});
